import React, { useState } from 'react';
import moment from 'moment-timezone';

const TimezoneSelector = ({ onTimezoneChange }) => {
  const [selectedTimezone, setSelectedTimezone] = useState(moment.tz.guess()); // Default to detected timezone

  const handleChange = (event) => {
    const newTimezone = event.target.value;
    setSelectedTimezone(newTimezone);
    onTimezoneChange(newTimezone); // Notify parent about timezone change
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <label htmlFor="timezone-selector" style={{ marginRight: '10px' }}>
        Select Timezone:
      </label>
      <select
        id="timezone-selector"
        value={selectedTimezone}
        onChange={handleChange}
        style={{ padding: '5px', fontSize: '14px' }}
      >
        {moment.tz.names().map((timezone) => (
          <option key={timezone} value={timezone}>
            {timezone}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimezoneSelector;
